import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { Sector } from 'src/app/shared/interfaces/sector.interface';
import { SectorService } from '../sector.service';

@Component({
  selector: 'app-sector-view',
  templateUrl: './sector-view.component.html',
  styleUrls: ['./sector-view.component.css'],
})
export class SectorViewComponent implements OnInit {
  sector: Sector;

  constructor(
    private activatedRoute: ActivatedRoute,
    private toater: ToastrService,
    private sectorService: SectorService,
    private loadService: LoaderService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.getSector(params.id);
    });
  }
  getSector(id: number): Promise<void> {
    this.loadService.showLoader();
    return this.sectorService
      .getById(id)
      .then((res) => {
        this.sector = res;
        this.loadService.closeLoader();
      })
      .catch((err) => {
        this.toater.error(err.messsage || 'Falha ao carregar setor!');
        this.loadService.closeLoader();
      });
  }
}
